/**
 * templates-api.ts — API client for task templates
 */
import { apiClient } from './index';

export interface TaskTemplate {
    id: string;
    name: string;
    description: string;
    priority: string;
    estimated_hours?: number;
    created_by: string;
    created_at: string;
}

export interface CreateTemplateInput {
    name: string;
    description: string;
    priority: string;
    estimated_hours?: number;
}

export async function getTemplates(): Promise<TaskTemplate[]> {
    const res = await apiClient.get<{ data: TaskTemplate[] }>('/templates');
    return res.data.data ?? [];
}

export async function createTemplate(input: CreateTemplateInput): Promise<TaskTemplate> {
    const res = await apiClient.post<TaskTemplate>('/templates', input);
    return res.data;
}

export async function deleteTemplate(id: string): Promise<void> {
    await apiClient.delete(`/templates/${id}`);
}
